<div style="display: grid; grid-template-columns: 1fr 1fr; text-align: center">
    <div>
        <a href="javascript:void(0)" class="d-block text-gray-700 text-decoration-none dropdown-toggle me-3" (click)="open('Playground')">
            <img src="./assets/media/icons/suggestion.png" alt="Suggest improvements" width="24" height="24">
        </a>
    </div>
    <div>
        <a href="javascript:void(0)" class="d-block text-gray-700 text-decoration-none dropdown-toggle" (click)="open('Bug')">
            <img src="./assets/media/icons/bug2.png" alt="Report a bug" height="24">
        </a>
    </div>
</div>

<div *ngIf="suggestionBoxVisible" class="dropdown-menu suggestion-box-panel p-5 shadow-lg" style="display: block;">
    <form [formGroup]="form" (ngSubmit)="submitSuggestion()">
        <h3 class="mb-4">Tell us more!</h3>
        <select class="form-select mb-2" formControlName="type">
            <option value="Playground">Suggest improvements</option>
            <option value="Bug">Report a bug</option>
        </select>

        <input type="text" class="form-control mb-2" placeholder="Title" formControlName="title">

        <textarea class="form-control mb-2" formControlName="description" rows="4" placeholder="Describe your use case..."></textarea>

        <div class="row align-items-center g-1">
            <div class="col-auto">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" formControlName="make_screenshot" />
                    <label class="form-check-label" for="flexCheckChecked">
                    </label>
                </div>
            </div>
            <div class="col">
                <label class="form-check-label" for="flexCheckChecked" style="line-height: 14px">
                    Make page<br>screenshot
                </label>
            </div>
            <div class="col-auto">
                <button class="btn btn-primary" [disabled]="isSaving" [attr.data-kt-indicator]="isSaving ? 'on' : ''">
                    <span class="indicator-label">Send</span>
                    <span class="indicator-progress">
                  Sending... <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
                </button>
            </div>
        </div>
     </form>

</div>
